import React, { FunctionComponent } from 'react'

import { DateRangeFilter } from '../../../../components'

import { OverviewReportFilters } from '../Table'
import {
  TableChangeFilter,
  TableChangeFilters,
} from '../../../../contexts/TableContext'

import styles from './styles.module.css'

interface OverviewReportFiltersProps {
  filters: Partial<OverviewReportFilters>
  setFilter: TableChangeFilter<OverviewReportFilters>
  setFilters: TableChangeFilters<OverviewReportFilters>
}

const OverviewReportFilterDisplay: FunctionComponent<OverviewReportFiltersProps> = ({
  filters,
  setFilters,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <DateRangeFilter
          onChange={({ dateRange, startDate, endDate }) => {
            setFilters({
              dateRange,
              start: startDate,
              end: endDate,
            })
          }}
          dates={{
            startDate: filters.start,
            endDate: filters.end,
            dateRange: filters.dateRange,
          }}
        />
      </div>
    </div>
  )
}

export default OverviewReportFilterDisplay
